if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {

      constructor() {
        super()
        this.handleProductCardSwatchClick();
      }

      handleInsideLinkClick = (event) => {
        event.preventDefault();
      }

      fetchProduct(event) {

        const clickedElColor = event.target.dataset.productColor;

        event.preventDefault();

        //const isWithinSlider = this.closest('fostr-slider') !== null
        const isWithinCartDrawer = this.closest('#CartDrawer') !== null
        const isProductPage = document.body.classList.contains('product')
        const isMobile = window.innerWidth < 750

        let fetchCardString;

        if (isWithinCartDrawer) {
          fetchCardString = 'view=card-product-horizontal--swatches';
        } else {
          fetchCardString = 'view=card-product--swatches';
        }

        const baseUrl = event.target.dataset.productUrl;
        const separator = baseUrl.includes('?') ? '&' : '?';

        /*
        if ((isWithinSlider && isProductPage && isMobile) || (isWithinSlider && isWithinCartDrawer && isMobile)) {
          return
        }
        */

        fetch(baseUrl + separator + fetchCardString)
        .then(response => response.text())
        .then(text => {

          const initialProductGroupEl = this.querySelector('product-group');

          const newHtml = new DOMParser().parseFromString(text, 'text/html').querySelector('product-card').innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();

            if(initialProductGroupEl !== null) {
              this.querySelector('product-group').replaceWith(initialProductGroupEl);
              const productSwatches = this.querySelectorAll("product-group-swatch")
              productSwatches.forEach(swatch => {
                swatch.dataset.productColor !== clickedElColor ? swatch.classList.remove('current-swatch') : swatch.classList.add('current-swatch')
                swatch.dataset.productColor !== clickedElColor ? swatch.querySelector('a.product-group--item').classList.remove('current') : swatch.querySelector('a.product-group--item').classList.add('current')
              })
              this.querySelector('product-group').dataset.selectedType = `Colour: ${clickedElColor}`
            }
          }
        })
        .catch(e => {
          console.error(e);
        })

      }

      handleProductCardSwatchClick() {
        const swatches = this.querySelectorAll('product-group product-group-swatch');
        swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.fetchProduct.bind(this));
          swatch.querySelector('a.product-group--item')?.classList.add('js-load');
          swatch.querySelector('a.product-group--item')?.addEventListener('click', this.handleInsideLinkClick);
        });
      }

    }

    customElements.define('product-card', ProductCard)
  }
